import {configureStore} from "@reduxjs/toolkit"
import createSagaMiddleware from "redux-saga"
import studyReducer from "./study-redux-slice"
import rootSaga from "../firebase/sagas"

const sagaMiddleware = createSagaMiddleware()
export default () => {
    const store = configureStore({
        reducer: {
            study: studyReducer,
        },
        middleware: (getDefaultMiddleware) => [...getDefaultMiddleware({thunk: false}), sagaMiddleware]
    })
    sagaMiddleware.run(rootSaga)
    return store
}